window._ = require('lodash');
window.$ = window.jQuery = require('jquery');

require('imagesloaded');
require('jquery-custom-select');
require('jquery-match-height');

window.closestLocations = require('./components/closest-location');

require('../../node_modules/responsively-lazy/responsivelyLazy');
require('../../node_modules/isotope-layout/dist/isotope.pkgd');
require('../../node_modules/flickity/dist/flickity.pkgd');
require('./vendor/socialShare');
